import { makeStyles, createStyles, Theme } from '@material-ui/core/styles'
import {GREY_COLOR, PRIMARY_COLOR} from "~/constants/colors";

export default makeStyles((theme: Theme) =>
    createStyles({
        container: {
            background: GREY_COLOR.Grey6,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            height: 'calc( 100vh - 80px )',
            [theme.breakpoints.down('md')]: {
                height: 'auto'
            },
            [theme.breakpoints.down('sm')]: {
                padding: '34px 40px 18px',
                height: 'calc(100vh - 137px)',
                zIndex: 10
            },
            [theme.breakpoints.down('xs')]: {
                padding: '0 16px 18px',
                height: 'calc(100vh - 126px)',
            }
        },
        img: {
            marginTop: '52px',
            width: '296px',
            [theme.breakpoints.down('xs')]: {
                width: 213,
                marginTop: 40
            }
        },
        error: {
            fontFamily: 'Usual Light',
            fontSize: '90px',
            color: PRIMARY_COLOR.Primary1,
            fontWeight: 300,
            letterSpacing: '-1.25px',
            lineHeight: 'normal',
            [theme.breakpoints.down('xs')]: {
              fontSize: 50,
              letterSpacing: '-0.5px',
              marginTop: 40
            }
        },
        text: {
            maxWidth: '721px',
            color: GREY_COLOR.Grey2,
            letterSpacing: '-0.5px',
            fontSize: '50px',
            textAlign: 'center',
            lineHeight: 'normal',
            [theme.breakpoints.down('xs')]: {
              fontSize: 24,
              letterSpacing: '-0.25px'
            }
        },
        btn: {
            fontSize: 14,
            fontFamily: 'Usual',
            letterSpacing: '-0.5px',
            margin: '30px 0px'
        }
    })
)
